import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import {
	INCOMING_INVOICE_CHECK_GROUPS,
	INCOMING_INVOICE_CHECKS,
} from "@msuite/utils/incoming-invoices";
import type { IncomingInvoiceCheckList } from "@msuite/utils/types";
import { IncomingInvoiceCheckGroup } from "./incoming-invoice-check-group";

/** Props Interface */
interface IncomingInvoiceChecksProps {
	checks: IncomingInvoiceCheckList;
	/** The invoice's currency, for the amounts a failed sum is off by. */
	currency: string;
}

/**
 * The review checks of an invoice, grouped in the order `INCOMING_INVOICE_CHECKS` lists them.
 * Every check of the list is shown, also one the invoice has no outcome for yet.
 */
export function IncomingInvoiceChecks({ checks, currency }: IncomingInvoiceChecksProps) {
	/** Context */
	const { t } = useTranslation();

	/** Render */
	return (
		<ContentCard
			title={t("incoming_invoices.review")}
			icon={icon("ClipboardCheck")}
		>
			<div className="v-stack gap-4">
				{INCOMING_INVOICE_CHECK_GROUPS.map((group) => (
					<IncomingInvoiceCheckGroup
						key={group}
						group={group}
						checkKeys={INCOMING_INVOICE_CHECKS.filter((check) => check.group === group).map(
							(check) => check.key,
						)}
						checks={checks}
						currency={currency}
					/>
				))}
			</div>
		</ContentCard>
	);
}
